import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useOVIDMutation } from '@outdoor-voices/ui/dist/utils/customer/OVIDClient';
import { useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { actionCreate } from './queries';
import css from './SMSSignUp.module.scss';
import ConciergeSignUp from './ConciergeSignUp';
import Image from '../Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Form = function Form(_ref) {
  var disclaimerPreSubmit = _ref.disclaimerPreSubmit,
      disclaimerPostSubmit = _ref.disclaimerPostSubmit,
      _ref$success = _ref.success,
      title = _ref$success.title,
      message = _ref$success.message,
      utmCampaign = _ref.utmCampaign;
  var CONCIERGE_CONFIG = {
    orgName: 'Outdoor Voices',
    header: '',
    subheader: '',
    phonePlaceholder: 'Enter your phone number',
    // TODO: This feature doesn't work currently, contact Concierge
    buttonText: 'Submit',
    successText: '',
    formContainerStyle: {},
    buttonStyle: {},
    buttonDisabledStyle: {
      cursor: 'not-allowed'
    },
    headerStyle: {
      display: 'none'
    },
    subheaderStyle: {
      display: 'none'
    },
    phoneInputStyle: {},
    smsLegalNoticeStyle: {
      display: 'none'
    },
    smsLegalNotice: ''
  };

  var _useOVIDMutation = useOVIDMutation({
    query: actionCreate
  }),
      mutate = _useOVIDMutation.mutate;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitted = _useState2[0],
      setSubmitted = _useState2[1];

  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.formWrapper, _defineProperty({}, css.submitted, submitted)]),
    children: [!submitted && /*#__PURE__*/_jsx("div", {
      className: css.conciergeForm,
      children: /*#__PURE__*/_jsx(ConciergeSignUp, {
        options: {
          utm_campaign: utmCampaign
        },
        configuration: _objectSpread(_objectSpread({}, CONCIERGE_CONFIG), {}, {
          onSuccess: function () {
            var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return mutate({
                        variables: {
                          actionName: 'subscribe_sms'
                        }
                      });

                    case 2:
                      setSubmitted(true);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function onSuccess() {
              return _onSuccess.apply(this, arguments);
            }

            return onSuccess;
          }()
        })
      })
    }), submitted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h3", {
        className: css.successTitle,
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: css.successMessage,
        dangerouslySetInnerHTML: {
          __html: message
        }
      })]
    }), disclaimerPreSubmit && !submitted && /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      dangerouslySetInnerHTML: {
        __html: disclaimerPreSubmit
      }
    }), disclaimerPostSubmit && submitted && /*#__PURE__*/_jsx("p", {
      className: css.disclaimer,
      dangerouslySetInnerHTML: {
        __html: disclaimerPostSubmit
      }
    })]
  });
};

Form.defaultProps = {
  disclaimerPreSubmit: false,
  disclaimerPostSubmit: false,
  utmCampaign: ''
};
Form.propTypes = {
  disclaimerPreSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disclaimerPostSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  success: PropTypes.shape({
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  utmCampaign: PropTypes.string.isRequired
};

var SMSSignUp = function SMSSignUp(_ref3) {
  var blurb = _ref3.blurb,
      disclaimerPreSubmit = _ref3.disclaimerPreSubmit,
      disclaimerPostSubmit = _ref3.disclaimerPostSubmit,
      imageDesktop = _ref3.imageDesktop,
      imageMobile = _ref3.imageMobile,
      success = _ref3.success,
      title = _ref3.title,
      utmCampaign = _ref3.utmCampaign;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.imageWrapper,
      children: [/*#__PURE__*/_jsx(Image, _objectSpread({
        className: css.desktop
      }, imageDesktop)), /*#__PURE__*/_jsx(Image, _objectSpread({
        className: css.mobile
      }, imageMobile))]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.contentWrapper,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("h2", {
        className: css.blurb,
        dangerouslySetInnerHTML: {
          __html: blurb
        }
      }), /*#__PURE__*/_jsx(Form, {
        disclaimerPreSubmit: disclaimerPreSubmit,
        disclaimerPostSubmit: disclaimerPostSubmit,
        utmCampaign: utmCampaign,
        success: success
      })]
    })]
  });
};

SMSSignUp.defaultProps = {
  blurb: '',
  disclaimerPreSubmit: false,
  disclaimerPostSubmit: false,
  title: '',
  utmCampaign: ''
};
SMSSignUp.propTypes = {
  blurb: PropTypes.string.isRequired,
  disclaimerPreSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disclaimerPostSubmit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  imageDesktop: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageMobile: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  success: PropTypes.shape({
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  utmCampaign: PropTypes.string.isRequired
};
export default SMSSignUp;